"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelestriasStarfallAbilityHandler = exports.TelestriasStarfallActorAbilityFactory = exports.TelestriasStarfallAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Slow_1 = require("../../core/effects/core/Slow");
const Stardust_1 = require("../../core/effects/core/Stardust");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class TelestriasStarfallAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TelestriasStarfall;
        this.__typeName = "TelestriasStarfall";
    }
}
exports.TelestriasStarfallAbilityArgs = TelestriasStarfallAbilityArgs;
let TelestriasStarfallActorAbilityFactory = class TelestriasStarfallActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TelestriasStarfall", "AllEnemies", 2);
    }
};
TelestriasStarfallActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TelestriasStarfall")
], TelestriasStarfallActorAbilityFactory);
exports.TelestriasStarfallActorAbilityFactory = TelestriasStarfallActorAbilityFactory;
let TelestriasStarfallAbilityHandler = class TelestriasStarfallAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        for (const enemy of enemies) {
            container.applyAttackWithDamage({
                sequence,
                abilityKey: ability.args.__typeName,
                attackType: "magic",
                attackerId: ability.invokerId,
                targetId: enemy,
                toApply: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", 130)
                ],
                onHit(sequence) {
                    container.applyDebuffs({
                        attackerId: ability.invokerId,
                        targetId: enemy,
                        effects: [
                            {
                                effect: new Slow_1.SlowEffectArgs(2),
                                duration: Duration_1.Duration.Turns(3),
                            },
                            {
                                effect: new Stardust_1.StardustEffectArgs(),
                                duration: Duration_1.Duration.Permanent,
                            }
                        ],
                        sequence
                    });
                }
            });
        }
    }
};
TelestriasStarfallAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TelestriasStarfall)
], TelestriasStarfallAbilityHandler);
exports.TelestriasStarfallAbilityHandler = TelestriasStarfallAbilityHandler;
